<template>
  <el-dialog title="用户协议" :before-close="close" left :close-on-click-modal="false" :width="'820px'" :visible.sync="visible">
    <p class="agrcontent">
      为了更好地为您提供服务，请您仔细阅读这份协议，理解认同后再进行注册。本协议是您与本平台就您注册、登录本平台及使用等所涉及的全部行为所订立的权利义务规范。您在注册过程中点击“同意”等按钮、及注册后登录和使用时，均表明您已完全充分理解、同意并接受本协议，愿意遵守本协议及的各项规则、规范的全部内容，若不同意则可停止注册、登录或使用平台。<br>
      <strong>一、定义</strong><br>
      <strong>1.1</strong> 您：指提交有效申请并注册后，在本平台登录、上传、发布、提供链接等以各种形式传播内容（包括文字、图片、音频、视频、图表、漫画等）的自然人、法人或其他组织。<br>
      <strong>1.2</strong> 本平台运营方是成都青之软件有限公司成都总公司。<br>
      <strong>二、帐户注册和使用</strong><br>
      <strong>2.1</strong> 在注册、使用和管理平台帐户时，请您使用真实、准确、合法、有效的相关身份证明材料及必要信息（包括您的姓名及电子邮件地址、联系电话、联系地址等），以便本平台在必要时与您联系，并注意及时更新。为使您更好地使用平台的各项服务，请您按照相关法律规定及平台要求完成实名认证。您应当对您提供的帐号资料的真实性、合法性、准确性和有效性独立承担责任。如因此给平台公司或第三方造成损害的，您应当依法予以赔偿。<br>
      <strong>2.2</strong> 为保障用户和公司利益，平台公司有权核查您提交的相关材料（如自然人身份证复印件、企业法人营业执照副本复印件、事业单位法人证书复印件、公司官方声明/说明等）后再决定是否核准您的注册申请。若您提交的材料或填写的信息不完整或不准确，则您可能无法使用本服务或在使用过程中受到限制。<br>
      <strong>2.3</strong> 您所设置的帐户名不得违反国家法律法规及平台规则关于帐户名的管理规定，否则本平台可对您的帐户名进行暂停使用或注销等处理，并向主管机关报告。<br>
      <strong>2.4</strong> 您理解并承诺，您的帐户名称、头像和简介等注册信息中不得出现违法和不良信息，没有冒用、关联机构或社会名人，您在帐户注册过程中需遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等七条底线。<br>
    </p>
    <span slot="footer" class="dialog-footer">
      <el-button @click="$router.push({ name: 'login' })">取 消</el-button>
      <el-button type="primary" @click="visible = false">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false
    };
  },
  methods:{
    close(){
      this.$router.push({ name: 'login' });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body{
  width: 728px;
  background: #EEF4F9;
  border-radius: 8px;
  margin: 0 auto;
  padding: 16px;
  margin-top: 12px;
}
.agrcontent {
  line-height: 25px;
  max-height: 350px;
  overflow: hidden;
  overflow-y: auto;
  button {
    background: #1460ae;
  }
}
</style>
